module.exports = __webpack_public_path__ + "static/media/bluesnap.b1398185.png";